import React, { useState } from 'react';
import ProductCard from '../../components/ProductCard/ProductCard';
import ReviewSlider from '../../components/ReviewSlider/ReviewSlider';
import useScrollReveal from '../../hooks/useScrollReveal';
import { products } from '../../data/products';
import { reviews } from '../../data/reviews';
import productsBanner from '../../assets/another page banner/our products.jpg';
import './Products.css';

export default function Products() {
  const [activeCategory, setActiveCategory] = useState('aerospace');
  const gridRef = useScrollReveal();

  const categories = [
    { label: 'Aerospace',    value: 'aerospace',  count: products.filter(p => p.category === 'aerospace').length,  icon: '🚀' },
    { label: 'Windmill',     value: 'windmill',   count: products.filter(p => p.category === 'windmill').length,   icon: '🌬️' },
    { label: 'Cement',       value: 'cement',     count: products.filter(p => p.category === 'cement').length,     icon: '⚙️' },
    { label: 'Defence',      value: 'defence',    count: products.filter(p => p.category === 'defence').length,    icon: '🛡️' },
    { label: 'All Products', value: 'all',        count: products.length,                                          icon: '◾' },
  ];

  const filtered = activeCategory === 'all' ? products : products.filter(p => p.category === activeCategory);

  return (
    <main className="products-page">
      <section className="page-hero">
        <div className="page-hero__bg">
          <img src={productsBanner} alt="Our Products" className="page-hero__bg-img" />
          <div className="page-hero__bg-overlay" />
        </div>
        <div className="container page-hero__content">
          <p className="page-hero__tag">Manufacturing Excellence</p>
          <h1 className="page-hero__title display">Our Products</h1>
          <p className="page-hero__sub">Engineered components for ISRO, BrahMos, L&amp;T and India's most demanding aerospace programmes.</p>
        </div>
      </section>

      <div className="page-hero__filter-bar">
        <div className="container">
          <div className="filter-bar">
            {categories.map(c => (
              <button
                key={c.value}
                className={`filter-btn ${activeCategory === c.value ? 'filter-btn--active' : ''}`}
                onClick={() => setActiveCategory(c.value)}
              >
                <span className="filter-btn__icon">{c.icon}</span>
                {c.label}
                <span className="filter-btn__count">{c.count}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      <section className="section" ref={gridRef}>
        <div className="container">
          {filtered.length > 0 ? (
            <div className="products-grid stagger">
              {filtered.map((p) => (
                <div key={p.id} className="reveal">
                  <ProductCard product={p}/>
                </div>
              ))}
            </div>
          ) : (
            <div className="products-empty-state">
              <div className="products-empty-state__icon">⚙️</div>
              <h3 className="products-empty-state__title">Product Gallery Coming Soon</h3>
              <p className="products-empty-state__sub">Detailed product images for this category are being prepared. Contact us directly for specifications and availability.</p>
              <a href="/contact" className="btn btn-primary" style={{marginTop:'1.5rem'}}>Get in Touch →</a>
            </div>
          )}
        </div>
      </section>

      <section className="section bg-indigo-lt">
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '3rem' }}>What Our Clients Say</h2>
          <ReviewSlider reviews={reviews}/>
        </div>
      </section>
    </main>
  );
}